/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Service } from '@roc/feature-app-core';
import { Extension } from '../stores/extensionsStore';

export interface LoanExtensionSubmitResponse {
  success: boolean;
  loanExtensionId?: number;
  responseMessage?: string;
}

const url = {
  GET_LOAN_EXTENSIONS_BY_LOAN_ID: '/api/v1/loan/loanExtension/getLoanExtensionsByLoanId',
  GET_LOAN_EXTENSION_BY_ID: '/api/v1/loan/loanExtension/getLoanExtensionById',
  GET_CURRENT_EXTENSION_FOR_LOAN: '/api/v1/loan/loanExtension/getCurrentExtensionForLoan',
  GET_DOCUSIGN_DETAILS: '/api/v1/loan/loanExtension/getSignatureRequests',
  PREVIEW_EXTENSION_AGREEMENT: '/api/v1/loan/loanExtension/previewExtensionAgreement',
  MARK_EXTENSION_AS_VOID: '/api/v1/loan/loanExtension/markExtensionAgreementAsVoid',
  RESEND_PENDING_DOCUSIGNS: '/api/v1/loan/loanExtension/resendPendingSignatureRequests',
  SUBMIT_LOAN_EXTENSION: '/api/v1/loan/loanExtension/submit',
  MARK_LOAN_EXTENSION_AS_COMPLETE: '/api/v1/loan/loanExtension/markAsComplete',
  SUBMIT_LOAN_EXTENSION_INTERNAL: '/api/v1/loan/loanExtension/submit',
  REQUEST_EXTENSION_AGREEMENT: '/api/v1/loan/loanExtension/requestExtensionAgreement',
  MARK_LOAN_EXTENSION_AS_RETRACTED: '/api/v1/loan/loanExtension/markExtensionAsRetracted',
};

export class ExtensionsInternalService extends Service {
  getLoanExtensionsByLoanId(loanId: string) {
    return this.get(`${url.GET_LOAN_EXTENSIONS_BY_LOAN_ID}?loanId=${loanId}`);
  }

  getLoanExtensionById(loanExtensionId: number) {
    return this.get(`${url.GET_LOAN_EXTENSION_BY_ID}?loanExtensionId=${loanExtensionId}`);
  }

  submitLoanExtension(payload: {
    notes?: string;
    loanId: string;
    status?: string;
    dealName?: string;
    requestDate: string;
    newMaturityDate: any;
    loanExtensionId?: number;
    totalExtensionFee: string;
    extensionDuration: any;
    extensionWarnings?: string;
    extensionInsurance?: string;
    existingMaturityDate: string;
  }) {
    return this.post(url.SUBMIT_LOAN_EXTENSION, payload);
  }

  submitLoanExtensionInternal(payload: Extension) {
    return this.post(url.SUBMIT_LOAN_EXTENSION_INTERNAL, payload);
  }

  getCurrentExtensionForLoan(loanId: number) {
    return this.get(`${url.GET_CURRENT_EXTENSION_FOR_LOAN}?loanId=${loanId}`);
  }

  getSignatureRequests(entityId: number) {
    return this.get(`${url.GET_DOCUSIGN_DETAILS}?entityId=${entityId}`);
  }

  previewExtensionAgreement(extension: any) {
    return this.post(
      url.PREVIEW_EXTENSION_AGREEMENT,
      extension,
      {},
      { responseType: 'arraybuffer' }
    );
  }

  markExtensionAgreementAsVoid(loanExtensionId: number) {
    return this.post(`${url.MARK_EXTENSION_AS_VOID}?loanExtensionId=${loanExtensionId}`, {});
  }

  resendPendingSignatureRequests(loanExtensionId: number) {
    return this.get(`${url.RESEND_PENDING_DOCUSIGNS}?loanExtensionId=${loanExtensionId}`);
  }

  markLoanExtensionAsComplete(loanExtensionId: number) {
    return this.get(`${url.MARK_LOAN_EXTENSION_AS_COMPLETE}?loanExtensionId=${loanExtensionId}`);
  }

  markLoanExtensionAsRetracted(loanExtensionId: number) {
    return this.get(`${url.MARK_LOAN_EXTENSION_AS_RETRACTED}?loanExtensionId=${loanExtensionId}`);
  }

  requestExtensionAgreement(payload: Extension) {
    return this.post(url.REQUEST_EXTENSION_AGREEMENT, payload);
  }
}
